import React, { useState } from 'react';
import styles from '../../styles/RolesPermissionsStyles/RolesPermissions.module.css';

function RolesList({ roles = [], selectedRole, onRoleSelect, onNewRole }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredRoles = roles.filter(role =>
    role.nombre_rol.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.rolesListContainer}>
      <div className={styles.rolesListHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div className={styles.searchContainer} style={{ flex: 1 }}>
            <div className={styles.searchInputContainer}>
              <div className={styles.searchIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                </svg>
              </div>
              <input
                type="text"
                className={styles.searchInput}
                placeholder="Buscar Rol"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          {onNewRole && (
            <button
              className={styles.newRoleButton}
              style={{ marginLeft: 8 }}
              onClick={onNewRole}
              type="button"
            >
              + Nuevo Rol
            </button>
          )}
        </div>
      </div>
      <div className={styles.rolesList}>
        {filteredRoles.length > 0 ? (
          filteredRoles.map((role) => (
            <div
              key={role.id_rol}
              className={`${styles.roleItem} ${selectedRole?.id_rol === role.id_rol ? styles.roleItemActive : ''}`}
              onClick={() => onRoleSelect(role)}
            >
              <span className={styles.roleName}>{role.nombre_rol}</span>
            </div>
          ))
        ) : (
          <div className={styles.noRolesMessage}>
            <p>No se encontraron roles</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default RolesList;
